import React from "react";
import { useTranslation } from "react-i18next";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import { MODAL_TYPES } from "../../utils/emitter";
import useModalActions from "../../hooks/useModalActions";

// Попап «создать тест» из блока лояльности ЛК (ТЗ п.6.4.1): описание + крестик.
// Текст — черновик (в ТЗ приложен картинкой image8), на согласовании у заказчика.
export default function CreateTestInfoModal() {
  const { t } = useTranslation();
  const { closeModal } = useModalActions();

  return (
    <BaseModal
      className="create-test-info-modal"
      eventTypeModal={MODAL_TYPES.CREATE_TEST_INFO}
      title={t("loyalty.create_test_info.title")}
      description={t("loyalty.create_test_info.text")}
    >
      <BaseButton onClick={() => closeModal(MODAL_TYPES.CREATE_TEST_INFO)}>
        {t("loyalty.create_test_info.ok_btn")}
      </BaseButton>
    </BaseModal>
  );
}
